import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`New Components start as Primer Recipes`}</h2>
    <p><strong parentName="p">{`Open Source contributors`}</strong>{`: Please `}<a parentName="p" {...{
        "href": "https://github.com/primer/react/discussions/new?category=ideas"
      }}>{`open a discussion in Primer React`}</a>{` if you'd like to provide feedback on existing components or suggest component additions for the library.`}</p>
    <p><strong parentName="p">{`GitHub Staff Only`}</strong>{`: See `}<a parentName="p" {...{
        "href": "#"
      }}>{`HubPost Guidance on creating Primer Recipes`}</a></p>
    <h2>{`Upstreaming to Primer for GitHub Staff`}</h2>
    <p>{`Once you've created a Primer Recipe and it is in the adoption phase, you can nominate it for upstreaming to Primer. Primer has a strict process for adding new components to ensure they meet certain quality criteria and are accessible.`}</p>
    <p><strong parentName="p">{`Initiated by Primer:`}</strong>{` Primer maintainers will regularly review recipes and identify candidates to upstream into the Primer libraries.`}</p>
    <p><strong parentName="p">{`Initiated by a feature team:`}</strong>{` Feature teams can nominate their Primer Recipes for upstreaming by adding a comment on their existing Primer Recipe tracking issue. Primer maintainers will respond with a review and guidance on the process.`}</p>
    <h3>{`How do Primer maintainers arrive at a decision to upstream?`}</h3>
    <ul>
      <li parentName="ul">{`Is the pattern frequently used by multiple feature teams?`}</li>
      <li parentName="ul">{`Is this a pattern we want to encourage because it does a good job solving a particular design, engineering, or accessibility problem?`}</li>
      <li parentName="ul">{`Will there be any negative consequences from adding this new component? For example, a negative impact on performance`}</li>
      <li parentName="ul">{`Does it fit in with a “theme” of any existing Primer components? For example, a new data input component would fit in nicely with our existing form components and other patterns for data input`}</li>
      <li parentName="ul">{`Is the time we'd have to invest in owning and maintaining the component worth it?`}</li>
    </ul>
    <h4>{`Who are the decision makers and stakeholders involved?`}</h4>
    <p>{`The Primer maintainers (designers and engineers) will decide if a component should be upstreamed using input from feature teams and the criteria described above.`}</p>
    <h4>{`How do Primer maintainers vet components once they're upstreamed?`}</h4>
    <p>{`Once a component is upstreamed, it goes through the `}<a parentName="p" {...{
        "href": "/guides/component-lifecycle"
      }}>{`component lifecycle maturity`}</a>{` process.`}</p>
    <h3>{`Avoiding duplication`}</h3>
    <p>{`New components and Primer Recipes should never have the same name as an existing Primer component - especially if it's distinctly different from the existing component. The only exception is if you're introducing the React implementation of a component that has already been created in `}<a parentName="p" {...{
        "href": "https://github.com/primer/view_components/"
      }}>{`Primer ViewComponents`}</a>{`.`}</p>
    <p>{`If you're creating a modified version of an existing component, try to modify it in Primer first. If your changes are rejected by Primer, you can iterate on a "fork" of the component with a new name until it can be upstreamed. See `}<a parentName="p" {...{
        "href": "https://primer.style/design/guides/contribute/handling-new-patterns#process-summarized-as-flowchart"
      }}>{`the flowchart`}</a>{` in the "Handling new patterns" guidelines.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      